<div class="container-xxl">
  <div class="row no-gutters">
    <div class="col-8 d-none d-lg-flex justify-content-end">
      <div app-top-navigation role="navigation"></div>
    </div>
    <div class="col-8">
      <div app-navigation></div>
    </div>
  </div>
</div>